<template>
  <div class="card mt-5" @click="toggleProcedureDocuments">
    <v-row>
      <v-col class="pt-0 pb-0 pr-5 flx">
        <div class="info-header d-flex align-start mt-2">
          <div class="me-auto">
            <div class="good-name" @click.stop="showProcedure(item.p.id)">
              {{ item.p.goodName }}
              <openCloseIconInfo
                  :isClosed="item.p.isClosed"
              />
            </div>
            <div class="organization">
              {{ item.p.organizationName }}
            </div>
            <div class="procedure-status">{{ item.p.procedureTypeName }}</div>
          </div>
          <div>
            <v-chip class="info-status" v-bind:style="statusColor">
              <div>{{ item.p.status }}</div>
              <template v-slot:append>
                <v-icon class="cup-icon" v-if="showWinnerCup(item)">custom:winnerCup</v-icon>
              </template>
            </v-chip>
          </div>
        </div>
        <div class="procedure-name mt-auto" >
          {{ item.p.registryNumber || item.p.status }}
          <span v-if="item.p.applicationsQuantity !== null" class="applicationsQuantity">
            · {{ $t('Заявок:') }} {{ item.p.applicationsQuantity }}
          </span>
        </div>
        <div
          class="procedureDocuments"
          v-show="procedureDocuments.show"
        >
          <v-chip
            v-for="(document, index) in item.procedureDocuments"
            :ref="'procedureDocument' + index"
            :id="'procedure-' + item.p.id + '-document-' + index"
            v-show="
              index < 3 ? true : procedureDocuments.showAdditionalDocuments
            "
            :key="document.id"
            class="document"
            @click.stop="downloadDocument(document.id)"
          >
            <FileIcon :size="'26px'" :document="document" />
            <span class="fileName">{{ document.fileName }}</span>
          </v-chip>
          <v-chip
            class="document"
            v-if="item.procedureDocuments.length > 3"
            v-show="this.procedureDocuments.showAdditionalToggler"
            @click.stop="showAdditionalDocuments"
          >
            <v-icon size="26" color="#162040">mdi-file-outline</v-icon>
            <span class="extra">+{{ item.procedureDocuments.length - 3 }}</span>
          </v-chip>
          <v-chip
            v-if="item.procedureDocuments.length > 1"
            class="document"
            @click.stop="downloadDocuments(item.p.id, ProcedureDocumentType.PROCEDURE.code)"
          >
            <v-icon size="26" color="#162040">mdi-download-outline</v-icon>
            <span class="extra">{{ $t('Скачать всё') }}</span>
          </v-chip>
        </div>
      </v-col>
      <v-divider class="intec-blue--border" vertical></v-divider>
      <v-col cols="3" class="right-block ml-5 mr-4">
        <div>
          <div class="textOverline blackLight">{{ $t('Начальная (максимальная) цена') }}</div>
          <div class="textPrice mb-2">
            {{ item.p.isWithoutStartMaxPrice ? $t('Без объявления цены') : formatStartPrice(item.p.startMaxPrice) + '$' }}
          </div>
          <div class="dates">
            <div class="textDate">{{ $t('Приём до: {_1}', { '_1': formatDateTimeNoTz(item.p.applicationDeadline) }) }}</div>
            <div class="textDate" v-show="this.publishDates.show">{{ $t('Размещена: {_1}', { '_1': formatDateTimeNoTz(item.p.publishedAt) }) }}</div>
            <div class="textDate" v-show="this.publishDates.show">{{ $t('Обновлена: {_1}', { '_1': formatDateTimeNoTz(item.p.modifiedAt) }) }}</div>
          </div>
        </div>
        <ProcedureActions v-show="true" :item="item" :tableModel="tableModel" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Config from '@/config';
import { formatDateTimeNoTz, formatStartPrice } from '@/filters';
import ProcedureActions from './ProcedureActions.vue';
import { useProcedureStepStore } from '@/stores/procedureStepStore'
import { mapStores } from "pinia";
import OpenCloseIconInfo from "@/components/procedure/OpenCloseIconInfo.vue";
import {ProcedureDocumentType} from '@/lib/file';
import FileIcon from "@/components/FileIcon.vue";

export default {
  name: 'ProcedureCard',
  components: { OpenCloseIconInfo, ProcedureActions, FileIcon },
  props: {
    item: {
      type: Object,
      required: true,
    },
    tableModel: {
      Object,
      required: true,
    },
  },
  data() {
    return {
      deletingDialog: {
        show: false,
        text: 'Документ удаляется',
      },
      procedureDocuments: {
        show: false,
        showAdditionalDocuments: false,
        showAdditionalToggler: true,
      },
      publishDates: {
        show: false,
      },
      formatDateTimeNoTz,
      formatStartPrice,
      shouldMoveDown: false,
      isGuest: Config.isGuest(),
      ProcedureDocumentType
    };
  },
  computed: {
    ...mapStores(useProcedureStepStore),
    statusColor: function () {
      return this.procedureStepStore.getStatusStyle(this.item.p.stepCode);
    }
  },
  methods: {
    showWinnerCup(item) {
      return item.p.stepCode === 'completed' && item.p.isWinner
    },
    async downloadDocument(documentId) {
      window.location.href = '/procedures/downloadDocument/' + documentId;
    },
    async downloadDocuments(procedureId, documentType) {
      window.location.href = `/procedures/downloadDocuments/${procedureId}/${documentType}`;
    },
    showProcedure(procedureId) {
      const route = this.isGuest
          ? this.$router.resolve({
            name: 'public.procedures.view',
            params: { id: procedureId },
          })
          : this.$router.resolve({
            name: 'procedures.view',
            params: { id: procedureId },
          });

      window.open(route.href, '_blank');
    },
    toggleProcedureDocuments() {
      this.procedureDocuments.show = !this.procedureDocuments.show;
      this.publishDates.show = !this.publishDates.show;
      this.procedureDocuments.showAdditionalDocuments = false;
      this.procedureDocuments.showAdditionalToggler = true;
      if (!this.item.procedureDocuments.length) {
        this.shouldMoveDown = !this.shouldMoveDown;
      }
    },
    showAdditionalDocuments() {
      this.procedureDocuments.showAdditionalDocuments = true;
      this.procedureDocuments.showAdditionalToggler = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* Card */
.card {
  font-family: var(--primary-font-family-name);
  padding: 20px 15px;
  background-color: rgb(var(--background-color));
  border-radius: 10px;
  border: 1px solid rgb(var(--grey-border-color));
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  transition: all 0.5s;
}
.card:hover {
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
}

/* Info column */
.info-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  gap: 20px;
}

.info-status {
  cursor: pointer;
  border-radius: var(--default-border-radius);
  padding: 8px 30px;
  font-weight: 500;
  font-size: 16px;
  height: 37px;
}

.good-name {
  cursor: pointer;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
}
.good-name:hover {
  text-decoration-line: underline;
}

.procedure-status {
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: rgba(0, 0, 0, 50%);
  margin-top: 2px;
}

.procedure-name {
  font-weight: 500;
  font-family: Manrope;
  color: rgba(0, 0, 0, 50%);
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
}
.flx {
  display: flex;
  flex-direction: column;
}
.organization {
  font-weight: 600;
  color: rgba(0, 0, 0, 50%);
  font-size: 15px;
  line-height: 20px;
  margin-top: 4px;
}

.move-down {
  margin-top: auto;
}

.procedureDocuments:not(:empty) * {
  margin: 12px 0 !important;
}

.procedureDocuments {
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 9px;
  align-self: stretch;
  flex-wrap: wrap;
  margin: 0;
  font-family: var(--primary-font-family-name);

  .document {
    display: flex;
    padding: 10px;
    align-items: center;
    gap: 9px;
    border-radius: 5px;
    background-color: rgb(var(--background-color)) !important;
    color: rgb(var(--primary-color));
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

    &:deep(.v-chip__underlay) {
      background-color: rgb(var(--background-color));
    }

    .fileName {
      text-decoration-line: underline;
    }

    .extra {
      text-decoration-line: none;
    }
  }

  .document:hover {
    border: 1px solid rgb(var(--border-color));
    padding: 9px;
  }

  .document:before {
    background-color: rgb(var(--background-color)) !important;
  }
}

.dates {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
  margin-bottom: 50px;

  .textDate {
    color: rgb(var(--black-color));
    font-family: var(--primary-font-family-name);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}

.textOverline {
  color: rgba(0, 0, 0, 50%);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.25rem;
}

.textPrice {
  font-family: Manrope, sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 2rem;
}

.textNds {
  font-family: Manrope;
  font-weight: 400;
  font-size: 16px;
}

.right-block {
  position: relative;
  min-width: 255px;
}

.cup-icon {
  margin-top: 2px;
  margin-left: 10px;
}
</style>
